import { ENTITY_LISTING_VIEW_TYPE } from './common'

export const LIST_VIEW_TYPE_WITH_PREVIEW = {
  [ENTITY_LISTING_VIEW_TYPE.board]: ENTITY_LISTING_VIEW_TYPE.boardWithPreview,
  [ENTITY_LISTING_VIEW_TYPE.table]: ENTITY_LISTING_VIEW_TYPE.tableWithPreview,
}

export const LIST_VIEW_TYPE_WITHOUT_PREVIEW = {
  [ENTITY_LISTING_VIEW_TYPE.boardWithPreview]: ENTITY_LISTING_VIEW_TYPE.board,
  [ENTITY_LISTING_VIEW_TYPE.tableWithPreview]: ENTITY_LISTING_VIEW_TYPE.table,
}
